function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  id: "Line_112",
  "data-name": "Line 112",
  x2: 36,
  transform: "translate(1 1.5)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_65",
  "data-name": "Ellipse 65",
  cx: 1.5,
  cy: 1.5,
  r: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_66",
  "data-name": "Ellipse 66",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(35)"
});

var SvgIconDirect = function SvgIconDirect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_82",
    "data-name": "Group 82",
    width: 38,
    height: 3,
    viewBox: "0 0 38 3",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDirect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_direct.4796a772.svg";
export { ForwardRef as ReactComponent };